import { useMemo } from "react";
import { selectors, useAppSelector } from "store";
export var useCupPumpOptions = function (nodeIds) {
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var selectedCupPumps = useAppSelector(selectors.selectSelectedDecentralPumps(nodeIds));
    var pumpOptions = useMemo(function () {
        if (!(systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.vacuumPumpComponents))
            return [];
        return Object.values(systemDataDefineParameters.vacuumPumpComponents).filter(function (component) {
            return (component.valid ||
                selectedCupPumps.map(function (pump) { return pump === null || pump === void 0 ? void 0 : pump.value; }).includes(component.value));
        });
    }, [selectedCupPumps, systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.vacuumPumpComponents]);
    var selectedPumpOptions = useMemo(function () {
        return pumpOptions.filter(function (option) {
            return option.value &&
                selectedCupPumps.map(function (pump) { return pump === null || pump === void 0 ? void 0 : pump.value; }).includes(option.value);
        });
    }, [selectedCupPumps, pumpOptions]);
    return { pumpOptions: pumpOptions, selectedPumpOptions: selectedPumpOptions };
};
